import React from 'react';

export default function HeadingPrimary({ className, children }) {
  return (
    <div>
      <h1 className={`heading-primary ${ className || ''}`}>
        {children}
      </h1>
    </div>
  );
}
